import { WEB_COMPONENT_GZ_ENDPOINT_FILTER } from '../../webcomponents.constants';
import { GzEndpointFilterWebComponent } from './component/GzEndpointFilterWebComponent';

export { GzEndpointFilterWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ENDPOINT_FILTER, GzEndpointFilterWebComponent);
